import "./FirstScreen.scss";
import { NewsInternational_Plain } from "../../../types/api/news-international.ts";
import { buildResponsiveImageSources } from "../../../utils/utils.tsx";

const FirstScreen = ({ data }: { data: NewsInternational_Plain }) => {
  return (
    <section className="news-first-screen">
      <div className="wrapper">
        <div className="news-first-screen__text">
          <h1>{data.data.title}</h1>
        </div>
        {buildResponsiveImageSources(
          data.data.titleImage,
          data.data.titleImageMob,
          undefined,
          data.data.title,
          true,
        )}
      </div>
    </section>
  );
};

export default FirstScreen;
